import { formatCurrency } from "../../lib/format";

interface PayoutSummaryProps {
  buyInPerTeam: number;
  totalPool: number;
}

/** The buy-in and total pool as two headline stat cards. */
export function PayoutSummary({ buyInPerTeam, totalPool }: PayoutSummaryProps) {
  return (
    <dl className="payout-stats">
      <div className="payout-stats__item">
        <dt>Buy-in per team</dt>
        <dd>{formatCurrency(buyInPerTeam)}</dd>
      </div>
      <div className="payout-stats__item">
        <dt>Total prize pool</dt>
        <dd>{formatCurrency(totalPool)}</dd>
      </div>
    </dl>
  );
}
